<template>
  <div class="info-wrap">
    <h1 class="title">{{ quesTitle }}</h1>
    <div class="detail">
      <div class="detail-item van-ellipsis">
        总分：<span>{{
          quesInfo?.totalScore !== null ? `${quesInfo?.totalScore}分` : '--'
        }}</span>
      </div>
      <div class="detail-item van-ellipsis">
        及格：<span>{{
          quesInfo?.scorePass !== null ? `${quesInfo?.scorePass}分` : '--'
        }}</span>
      </div>
      <div class="detail-item van-ellipsis">
        答题限制：<span>{{
          quesInfo?.timePass !== null ? `${quesInfo?.timePass}分钟` : '--'
        }}</span>
      </div>
    </div>
  </div>
  <!-- 成绩排名 -->
  <div class="rank-wrap">
    <h3 class="title">
      <Icon size="24" color="#3795FF" name="medal-o" />
      成绩排名（{{
        rankBase === 1 ? '总得分' : rankBase === 2 ? '平均分' : '最高分'
      }}）
    </h3>
    <div class="rank-info">
      <div class="rank-info-row">
        <div class="rank-info-row-item">当日排名</div>
        <div class="rank-info-row-item">
          {{
            personScore.dayRank == null
              ? '--'
              : (rankBase === 1
                  ? personScore.dayRank.totalScore
                  : rankBase === 2
                  ? personScore.dayRank?.avgScore?.toFixed(2)
                  : personScore.dayRank.maxScore) || 0
          }}分
        </div>
        <div class="rank-info-row-item">
          {{
            personScore.dayRank == null
              ? '--'
              : formatLongTime(personScore.dayRank.totalTime)
          }}
        </div>
        <div class="rank-info-row-item">
          {{
            personScore.dayRank == null || personScore.dayRank == 'null'
              ? '--'
              : personScore.dayRank.rowNum + '名'
          }}
        </div>
      </div>
      <div class="rank-info-row" style="margin-top: 20px">
        <div class="rank-info-row-item">总时段排名</div>
        <div class="rank-info-row-item">
          {{
            personScore.totalRank == null
              ? '--'
              : (rankBase === 1
                  ? personScore.totalRank.totalScore
                  : rankBase === 2
                  ? personScore.totalRank?.avgScore?.toFixed(2)
                  : personScore.totalRank.maxScore) || 0
          }}分
        </div>
        <div class="rank-info-row-item">
          {{
            personScore.totalRank == null
              ? '--'
              : formatLongTime(personScore.totalRank.totalTime)
          }}
        </div>
        <div class="rank-info-row-item">
          {{
            personScore.totalRank == null || personScore.totalRank == 'null'
              ? '--'
              : personScore.totalRank.rowNum + '名'
          }}
        </div>
      </div>
    </div>
  </div>
  <!-- 个人成绩 -->
  <div class="grades-wrap">
    <h3 class="title">
      <Icon size="24" color="#3795FF" name="records" />个人成绩
    </h3>
    <p class="loading" v-if="recordsLoading">加载中...</p>
    <template v-else>
      <p class="loading" v-if="recordsList.length === 0">您还没有成绩排名~</p>
      <ul v-else class="grades-list animate__animated animate__fadeIn">
        <li
          v-for="(item, index) in recordsList"
          :key="item"
          class="grades-item"
        >
          <span>第{{ index + 1 }}次</span>
          <span>{{ item?.score || 0 }}分</span>
          <span>{{ formatLongTime(item?.longTime) }}</span>
          <span>{{ formatTime(item?.createTime) }}</span>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { Icon } from 'vant'
import {
  getUserCurrentQuesInfo,
  getUserScore,
  getUserRank,
  getUserAchievements,
} from '@/api/person'
import { onMounted, reactive, ref } from 'vue'
import { formatDuring,  getQueryString } from '@/utils/tools'
import { useRoute } from 'vue-router'

// 获取信息
const useInfoEffect = () => {
  const recordsList = ref([])
  const store = useStore()
  const recordsLoading = ref(true)

  const questionActiveKey = getQueryString('questionActiveKey')
  const getInfo = async () => {
    recordsLoading.value = true
    try {
      const res = await getUserScore({
        questionActiveKey: questionActiveKey,
        token: store.getters.getToken,
      })
      if (res?.ok) {
        recordsList.value = res.data
      }
      recordsLoading.value = false
    } catch (e) {
      recordsLoading.value = false
    }
  }

  getInfo()

  return {
    recordsList,
    recordsLoading,
  }
}

// 获取当前卷子信息
const useQuesInfoEffect = () => {
  let quesTitle = decodeURIComponent(getQueryString('title'))

  if (!quesTitle) {
    quesTitle = document.title
  }

  const quesInfo = reactive({
    scorePass: 0,
    timePass: 0,
    totalScore: 0,
  })
  const store = useStore()

  const questionActiveKey = getQueryString('questionActiveKey')
  const getInfo = async () => {
    try {
      const res = await getUserCurrentQuesInfo({
        questionActiveKey: questionActiveKey,
        token: store.getters.getToken,
      })
      if (res.ok) {
        quesInfo.scorePass = res.data.scorePass
        quesInfo.timePass = res.data.timePass
        quesInfo.totalScore = res.data.totalScore
        console.log('quesInfo', quesInfo)
      }
    } catch (e) {}
  }

  getInfo()

  return {
    quesInfo,
    quesTitle,
  }
}

// 获取排名信息
const useRankInfoEffect = () => {
  const store = useStore()
  const rankInfo = reactive({
    avgRank: null,
    totalRank: null,
  })

  const questionActiveKey = getQueryString('questionActiveKey')
  const getRankInfo = async () => {
    const res = await getUserRank({
      token: store.getters.getToken,
      questionActiveKey: questionActiveKey,
    })
    rankInfo.avgRank = { ...res.data.avgRank }
    rankInfo.totalRank = { ...res.data.totalRank }
  }

  getRankInfo()

  return {
    rankInfo,
  }
}

// 设置过滤器
const useFormatEffect = () => {
  // 格式化时长
  const formatLongTime = (str) => {
    return str ? formatDuring(str) : '--'
  }
  // 格式化创建时间
  const formatTime = (str) => {
    const tmp = str
    return tmp ? tmp.substring(5, 16) : '--'
  }

  return {
    formatLongTime,
    formatTime,
  }
}

export default {
  components: {
    Icon,
  },
  setup() {
    // 卷子信息
    const { quesInfo, quesTitle } = useQuesInfoEffect()
    // 答题记录
    const { recordsList, recordsLoading } = useInfoEffect()

    const { formatLongTime, formatTime } = useFormatEffect()

    // 排名信息
    const { rankInfo } = useRankInfoEffect()

    onMounted(() => {
      fetchData()
    })

    // 获取个人成绩
    const route = useRoute()
    const personScore = ref([])
    const store = useStore()

    const fetchData = async () => {
      const res = await getUserAchievements({
        token: store.getters.getToken,
        questionActiveKey: route.query.questionActiveKey,
      })

      if (res.ok) {
        personScore.value = res.data
      }
    }

    const rankBase = store.getters.getRankConfig?.rankBase

    return {
      quesTitle,
      quesInfo,
      recordsList,
      recordsLoading,
      rankInfo,
      formatTime,
      formatLongTime,
      personScore,
      rankBase,
    }
  },
}
</script>

<style lang="scss" scoped>
.info-wrap {
  margin: 0 auto;
  width: 700px;
  min-height: 195px;
  background-color: #fff;
  border-radius: 5px;

  .title {
    margin: 0 35px 0 34px;
    padding: 43px 0 27px 0;
    border-bottom: 1px dashed #c7c7c7;
    text-align: center;
    font-size: 38px;
    line-height: 1.2;
    font-weight: bold;
    color: #3795ff;
  }

  .detail {
    display: flex;
    margin-top: 27px;
    .detail-item {
      min-height: 30px;
      text-align: center;
      font-size: 28px;
      color: #999999;
      border-right: 1px solid #e5e5e5;
      line-height: 1.5;
      &:nth-child(1) {
        width: 200px;
      }
      &:nth-child(2) {
        width: 212px;
      }
      &:last-child {
        padding-left: 10px;
        width: 266px;
        border: none;
      }

      span {
        color: #ff9900;
      }
    }
  }
}

.loading {
  margin-top: 60px;
  text-align: center;
  font-size: 30px;
  color: #999999;
}

.grades-wrap,
.rank-wrap {
  .title {
    display: flex;
    align-items: center;
    margin-left: 8px;
    padding: 22px 0;
    font-size: 32px;
    font-weight: bold;
    color: #333333;
  }
}

.grades-wrap {
  margin: 25px auto;
  padding-bottom: 48px;
  width: 700px;
  min-height: 244px;
  background-color: #fff;

  .grades-list {
    // margin: 0 37px;
    margin-top: 10px;
    .grades-item {
      display: flex;
      justify-content: space-between;
      margin-top: 39px;
      font-size: 28px;
      font-weight: 500;
      color: #999999;

      span {
        display: inline-block;
        width: 25%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
      }
      :last-child {
        width: 28%;
      }
    }
  }
}

.rank-wrap {
  margin: 0 auto;
  margin-top: 25px;
  width: 700px;
  height: 262px;
  background-color: #fff;

  .rank-info {
    display: flex;
    flex-direction: column;

    .rank-info-row {
      width: 100%;
      display: flex;
      flex-direction: row;
      margin-top: 15px;

      .rank-info-row-item {
        font-size: 28px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #999999;
        width: 25%;
        text-align: center;
      }
    }

    .info-item {
      margin-top: 35px;
      width: 50%;
      text-align: center;
      &:first-child {
        border-right: 1px solid #e5e5e5;
      }
      .score {
        font-size: 48px;
        font-weight: bold;
        color: #333333;
      }
      .text {
        margin-top: 28px;
        font-size: 28px;
        font-weight: 500;
        color: #999999;
      }
    }
  }
}
</style>
